import { sidebarItems } from '@/const/sidebar-items'
import { useAuthStore } from '@/stores/useAuthStore'
import { computed } from 'vue'

export function useSidebar() {
  const authStore = useAuthStore()
  const excludeRole = new Set(['User', 'Vendor', 'DIC'])

  /**
   * Menu Sidebar filtered based on user role
   */
  const filteredMenu = computed(() => {
    if (!authStore.user) return []
    const allowed = authStore.allowedNavigation
    return sidebarItems.filter(item => allowed.includes(item.to))
  })

  /**
   * Identify navigation that own by user is more than one
   * @type {import('vue').ComputedRef<boolean>}
   */
  const shouldRenderSidebar = computed(() => !excludeRole.has(authStore?.mappedUser?.role))

  return {
    filteredMenu,
    shouldRenderSidebar,
  }
}
